
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theatres/[slug]/[playSlug]",
      function () {
        return require("private-next-pages/theatres/[slug]/[playSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/theatres/[slug]/[playSlug]"])
      });
    }
  